import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type {
  AdminListTransferTicketsParams,
  AdminCloseTicketInput,
} from '../api'
import type { IMutationArgs } from '../types'
import { adminListTransferTicketsOptions } from './admin-transfer.options'
import adminTransferService from './admin-transfer.service'
import { ETransferQueryKey } from './admin-transfer.types'

export const useAdminListTransferTickets = (
  params: AdminListTransferTicketsParams,
) => {
  return useQuery(adminListTransferTicketsOptions(params))
}

export const useAdminCloseTransferTicket = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AdminCloseTicketInput) =>
      adminTransferService.adminCloseTransferTicket(data),
    mutationKey: [ETransferQueryKey.ADMIN_CLOSE_TRANSFER_TICKET],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [ETransferQueryKey.ADMIN_LIST_TRANSFER_TICKETS],
        })
      return data
    },
  })
}
